import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../state/store";
import StoreClosedOrderSchedulePopup from "../storeClosedOrderSchedulePopup/storeClosedOrderSchedulePopup";
import ScheduleOrdersPopup from "../scheduleOrdersPopup";


interface IOrderScheduleContainerProps {
  onClose: any;
  orderType: string;
  defaultDeliveryTime: any;
  defaultEta: any;
  openingHours: any;
  confirmScheduleDate: any;
  convertTo24Hours: (timeToConvert: any) => string;
  minimumEtaMinutes: any;
  hasLeadTime: boolean;
  cart: any;
  menu: any;
  for: string;
}

function OrderScheduleContainer(
  props: IOrderScheduleContainerProps
) {
  const { allow_order_when_closed = false } = useSelector(
    (state: RootState) => state.company?.configuration || {}
  );

  const { orderType } = props; // Destructure orderType from props
  const { open: storeOpen } = useSelector((state: RootState) => state.storeTimings);

  if (allow_order_when_closed && !storeOpen) {
    return (
      //1 month scheduler popup
      <StoreClosedOrderSchedulePopup
        onClose={props.onClose}
        for={orderType === "pickup" ? "Pickup" : "Delivery"}
        defaultEta={props.defaultEta}
        openingHours={props.openingHours}
        confirmScheduleDate={props.confirmScheduleDate}
        minimumEtaMinutes={props.minimumEtaMinutes}
        hasLeadTime={props.hasLeadTime}
      />
    );
  }

  return (
    <ScheduleOrdersPopup
      onClose={props.onClose}
      for={orderType === "pickup" ? "Pickup" : "Delivery"}
      defaultEta={props.defaultEta}
      openingHours={props.openingHours}
      defaultDeliveryTime={props.defaultDeliveryTime}
      confirmScheduleDate={props.confirmScheduleDate}
      minimumEtaMinutes={props.minimumEtaMinutes}
      hasLeadTime={props.hasLeadTime}
      convertTo24Hours={props.convertTo24Hours}
    />
  );
}

export default OrderScheduleContainer;
